export default __webpack_public_path__ + "static/media/H_Hamburguer.888a388f.mp3";